<template>
  <div>
    <van-coupon-cell
      :coupons="coupons"
      :chosen-coupon="chosenCoupon"
      @click="clickDialog"
    />
    <!-- 优惠券列表 -->
    <van-popup
      v-model="showList"
      round
      position="bottom"
      style="height: 90%; padding-top: 4px"
    >
      <van-coupon-list
        :coupons="coupons"
        :chosen-coupon="chosenCoupon"
        :disabled-coupons="disabledCoupons"
        :show-exchange-bar="false"
        @change="onChange"
      />
    </van-popup>
  </div>
</template>

<script>
import { Toast } from "vant";
export default {
  data() {
    return {
      chosenCoupon: -1,
      coupons: [], //可用
      disabledCoupons: [], //不可用
      showList: false,
      lists: [],
    };
  },
  props: {
    orderId: {
      required: true,
    },
  },
  methods: {
    clickDialog() {
      this.showList = true;
    },
    //日期时间转为时间戳
    getUnixTime(dateStr) {
      var newstr = dateStr.replace(/-/g, "/");
      var date = new Date(newstr);
      var time_str = date.getTime().toString();
      return time_str.substr(0, 10);
    },
    onChange(index) {
      console.log(index, "fsadf");
      this.chosenCoupon = index;
      if (this.chosenCoupon == -1) {
        this.$emit("callBack", {
          yhprice: "",
          code: "",
        });
        this.showList = false;
        return;
      }
      //计算价格
      this.$http
        .countPrice(this.orderId, this.coupons[index].code)
        .then((res) => {
          this.$emit("callBack", {
            yhprice: res,
            code: this.coupons[index].code,
          });
          this.showList = false;
        });
    },

    initData() {
      this.$http
        .getMyCard(this.orderId)
        .then((res) => {
          //处理字段格式
          let formateData = res.data.map((item) => {
            return Object.assign(
              {},
              {
                id: item.id,
                reason: item.reason,
                condition:
                  item.type == "fixed"
                    ? item.description
                    : `${this.composeNewStr(item.value, 1)}折`,
                name:
                  item.category && item.category.name
                    ? `适用版本：${item.category.name}`
                    : "适用版本：不限",
                startAt: this.getUnixTime(item.created_at),
                endAt: this.getUnixTime(item.enable_date),
                valueDesc:
                  item.type == "fixed"
                    ? item.value
                    : this.composeNewStr(item.value, 1),
                unitDesc: item.type == "fixed" ? "元" : "",
                code: item.code,
              }
            );
          });
          this.coupons = formateData.filter((item) => {
            return !item.reason;
          });
          this.disabledCoupons = formateData.filter((item) => {
            return item.reason;
          });
        })
        .catch((err) => {
          Toast(err.response.data.message);
        });
    },
    composeNewStr(str, index) {
      let string = str.slice(0, index) + "." + str.slice(index);
      return string.slice(0, 3);
    },
  },
  created() {
    this.initData();
  },
};
</script>

<style scoped >
/deep/ .van-coupon-cell__value--selected {
  display: none;
}
</style>